<template>
    <div
        ref="lyricContainer"
        class="lyricContainer"
        style="border: 0px solid white; position: relative; width: 100%"
        @mouseenter="showCloseButton = true"
        @mouseleave="showCloseButton = false"
    >
    <div style="margin-top: 40vh;" v-if="!info.lyrics">
        <span v-if="isLoading" class="loader"></span>
        <div v-else style="width: 100%;">
            <img style="width: 40%;" src="../assets/icebear.png" alt="">
            <p style="color: white; margin-top: -3%;">Lyrics not available</p>
        </div>
    </div>
    <v-list v-else default style="background-color: transparent; margin: 0; padding: 0;">
        <v-list-item v-for="(line, index) in info.lyrics" :key="index">
            <p onmouseover="this.style.textDecoration = 'underline'" onmouseout="this.style.textDecoration = 'none'" style="font-weight: bold; font-size: large;" @click="index != currentLyricIndex && jumpToTime(line.time)" :class="currentLyricIndex !== null && index <= currentLyricIndex? 'active' : 'inactive'">{{ line.text || '♪♪' }}</p>
        </v-list-item>
    </v-list>
   <div v-if="showCloseButton" class="glass close-btn" @click="queueStore.isLyricsVisible = false">
      <v-icon size="small" style="margin-right:5%;pointer-events:none">
        mdi-close
      </v-icon>
      <p style="font-size:small;color:#fff;pointer-events:none">
        Close
      </p>
    </div>
    </div>
</template>

<script>

import { EventBus } from '@/eventBus';
import { useToast } from 'vue-toastification';
import { useQueueStore } from '../stores/queue';
import { useLyricsStore } from '../stores/lyrics';

export default {
  name: "lyricsComponent",

  setup() {
    const queueStore = useQueueStore();
    const lyricsStore = useLyricsStore();
    return { queueStore, lyricsStore };
  },

  data() {
    return {
      info: this.queueStore.queue[this.queueStore.isPlayingIndex] || {},
      toast: useToast(),
      currentTime: 0,
      currentLyricIndex: null,
      autoscroll: true,
      userScrolling: false,
      scrollTimeout: null,
      isLoading: this.queueStore.isLoading,
      showCloseButton: false
    };
  },

  methods: {
    handleUserScroll() {
      if (!this.info || !this.info.lyrics  || !this.info.lyrics.length) return;
      this.autoscroll = false;
      this.userScrolling = true;

      if (this.scrollTimeout) clearTimeout(this.scrollTimeout);

      // Wait 2 seconds after last scroll to re-check
      this.scrollTimeout = setTimeout(() => {
        this.userScrolling = false;
        this.checkIfCurrentLineIsVisible();
      }, 2000);
    },

    checkIfCurrentLineIsVisible() {
      if (!this.info || !this.info.lyrics  || !this.info.lyrics.length) return;
      const lyricContainer = this.$refs.lyricContainer;
      if (!lyricContainer || this.currentLyricIndex === undefined) return;

      const currentEl = lyricContainer.querySelectorAll(".v-list-item")[this.currentLyricIndex];
      if (!currentEl) return;

      const containerTop = lyricContainer.scrollTop;
      const containerBottom = containerTop + lyricContainer.clientHeight;
      const elTop = currentEl.offsetTop;
      const elBottom = elTop + currentEl.offsetHeight;

      // If current line is visible in viewport, re-enable autoscroll
      if (elTop >= containerTop && elBottom <= containerBottom) {
        this.autoscroll = true;
      }
    },

    updateCurrentTime(time) {
      if (!this.info || !this.info.lyrics || !this.info.lyrics.length) return;
      // ── If time is exactly zero, do NOT highlight anything yet ──
      if (time === 0) {
        // Still update currentTime internally, but skip lyric‐index logic:
        this.currentTime = time;
        return;
      }

      // Once time > 0, run the normal logic:
      this.currentTime = time;
      this.checkIfCurrentLineIsVisible();

      const idx = this.info.lyrics.findIndex((line, i) => {
        return (
          line.time <= time &&
          (i === this.info.lyrics.length - 1 || this.info.lyrics[i + 1].time > time)
        );
      });

      if (idx !== -1 && idx !== this.currentLyricIndex) {
        this.currentLyricIndex = idx;
        if (this.autoscroll) {
          this.scrollToCurrentLine();
        }
      }
    },

    scrollToCurrentLine() {
      if (!this.info || !this.info.lyrics  || !this.info.lyrics.length) return;
      const lyricContainer = this.$refs.lyricContainer;
      if (!lyricContainer || this.currentLyricIndex === undefined) return;

      const currentEl = lyricContainer.querySelectorAll(".v-list-item")[this.currentLyricIndex];
      if (!currentEl) return;

      const containerHeight = lyricContainer.clientHeight;
      const scrollTop = currentEl.offsetTop - containerHeight / 2 + currentEl.offsetHeight;

      lyricContainer.scrollTo({
        top: Math.max(scrollTop, 0),
        behavior: "smooth",
      });
    },

    resetScrollPosition() {
      const lyricContainer = this.$refs.lyricContainer;
      if (lyricContainer) {
        lyricContainer.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
    },

    jumpToTime(time) {
      time && EventBus.emit('jumpToTime', time);
    }
  },
  activated(){
    if (this.info.id !== this.queueStore.queue[this.queueStore.isPlayingIndex]?.id) {
     this.info = this.queueStore.queue[this.queueStore.isPlayingIndex];
    }
  },
  mounted() {
    // Initialize with whatever was already in the queue:
    this.info = this.queueStore.queue[this.queueStore.isPlayingIndex];

    EventBus.on('info', (info) => {
        this.currentLyricIndex = null; // Reset current lyric index on new info
        this.info = info;
    });

    EventBus.on('updateCurrentTime', (val) => this.updateCurrentTime(val));

    EventBus.on('loading_info_1', () => {
      this.isLoading = true;
      if(this.info.id != this.queueStore.queue[this.queueStore.isPlayingIndex]?.id){
          this.info.lyrics = null;
      }
    });

    EventBus.on('loading_info_0', () => {
      this.isLoading = false;
    });

    const lyricContainer = this.$refs.lyricContainer;
    if (lyricContainer) {
      lyricContainer.addEventListener("scroll", this.handleUserScroll);
    }
  },

  beforeUnmount() {
    const lyricContainer = this.$refs.lyricContainer;
    if (lyricContainer) {
      lyricContainer.removeEventListener("scroll", this.handleUserScroll);
    }
  },

  watch:{
    'info.lyrics'(){
      setTimeout(() => {
        this.resetScrollPosition();
      }, 300)
    }
  }
};
</script>

<style scoped>
.active {
  color: white;}

.inactive {
  color: rgba(128, 128, 128, 0.685);
  cursor: pointer;
}

.inactive:hover {
  color: white;
  text-decoration: underline;
}

.lyricContainer{
  border: 0px solid white;
  position: absolute;
  right: 0;
  width: 20%;
  height: 100vh;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.close-btn {
    position: fixed;
    bottom: 2vh;
    right: 0;
    margin-right: 2vw;
    width: 20%;        /* same as lyric panel */
    display: flex;
    justify-content: center;
    align-items: center;
    height: 5vh;
    cursor: pointer;
    z-index: 100;
}

@media (max-width:675px) {
    .close-btn {
        width: 100%;
    }
}

@media screen and (max-width: 675px) {
  .lyricContainer {
    width: 100%;
    height: 80vh;
    z-index: 1;
    background-color: #000;
  }
}
      
    
</style>